import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { GeocodingTaskInfo } from '../models/GeocodingTaskInfo';
import { getOpenGeocodingConfigDialogAction } from './OpenGeocodingConfigDialogAction';

export const OpenGeocodingConfigDialogEntityAction: IEntityAction<GeocodingTaskInfo, {}> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editGeocodingConfig_action,
  isVisible: () => true,
  isClickable: (_availableActions: {}) => true,
  createReduxAction: (targetItems: GeocodingTaskInfo[]) => {
    return getOpenGeocodingConfigDialogAction(targetItems[0]);
  }
};
